module.exports = __webpack_public_path__ + "images/marketing/quickbooks-logo.png";